export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manawbg.3c778892.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};